import { IDotXetChungChi } from "../../../model/response/xet-chung-chi/IDotXetChungChi";
import { IDotXetChungChiViewModel } from "../../../model/response/xet-chung-chi/IDotXetChungChiViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotXetChungChiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDotXetChungChiViewModel[],
    LOAD_ERROR: "",

    SAVE_START: {} as IDotXetChungChi,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
    
    SHOW_EDIT_MODAL: {} as IDotXetChungChi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SHOW_THAM_SO_MODAL: 0,
    CLOSE_THAM_SO_MODAL: undefined,
}

export const eDotXetChungChiActionIds = generateActionTypeIds(eDotXetChungChiActionsObj, "DOT_XET_CHUNG_CHI");
export type IDotXetChungChiActionTypes = IGenericActionType<typeof eDotXetChungChiActionsObj, "DOT_XET_CHUNG_CHI">;